import axios from "axios";
export default axios.create({
  // baseURL: "https://red-onion-server-v2-6381301c4bdf.herokuapp.com/api/v2",
  // baseURL: "https://redonion-server.herokuapp.com/api/v2",
  baseURL: "https://api.redonion.io/api/v2",
});

